export default "__VITE_ASSET__C4$Fc52t__"